<template>
  <v-dialog v-model="open" max-width="300" @click:outside="$emit('cancel')">
    <v-card>
      <v-card-title>
        {{ $t('routines.cannot_delete_routine_title') }}
      </v-card-title>

      <v-card-text>
        {{ $t('routines.cannot_delete_routine_body') }}
      </v-card-text>

      <v-card-actions class="justify-end">
        <Button
          plain
          color="primary"
          :text="$t('common.button.close')"
          @click="$emit('cancel')"
        />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Button from '@/components/UI/Button'
export default {
  name: 'CannotDeleteDialog',
  components: {
    Button,
  },
  props: {
    open: {
      type: Boolean,
      required: true,
    },
  },
}
</script>
